import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import { acquireDocLock, releaseDocApiRequest } from 'src/types';
import { isUndefinedOrNull } from 'src/utils/general';

export default class DocumentLockApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async acquire(data: acquireDocLock): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return this.post(api.document_lock_acquire, formData);
  }

  public async release(data: releaseDocApiRequest): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      if (isUndefinedOrNull(value)) {
        continue;
      }
      formData.append(key, value.toString());
    }
    return this.post(api.document_release_lock, formData);
  }
}
